import { render, staticRenderFns } from "./sidebarMin.vue?vue&type=template&id=f48c2642&scoped=true&"
import script from "./sidebarMin.vue?vue&type=script&lang=js&"
export * from "./sidebarMin.vue?vue&type=script&lang=js&"
import style0 from "./sidebarMin.vue?vue&type=style&index=0&id=f48c2642&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f48c2642",
  null
  
)

export default component.exports